module.exports = __webpack_public_path__ + "img/pic-12.60f0646c.jpg";